var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 150,
    xmlns: "http://www.w3.org/2000/svg",
    desc: "Created with imagetracer.js version 1.2.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,226,224)",
    stroke: "rgb(220,226,224)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 66 Q 89.9 65.1 88 70.5 L 87 70.5 L 86.5 67 L 85.5 69 L 85 67.5 L 86.5 66 Z "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,226,224)",
    stroke: "rgb(220,226,224)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 66 Q 153.8 66.8 153 70.5 L 152 70.5 L 151.5 66 Z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,226,224)",
    stroke: "rgb(220,226,224)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 71 L 72.5 73 L 73.5 71 Z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,226,224)",
    stroke: "rgb(220,226,224)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 71 L 92 72.5 L 88 74 L 88 81.5 L 89.5 82 L 89.5 83 L 87 81.5 Q 85.3 74.8 88.5 73 Q 92 74 91.5 71 Z "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,226,224)",
    stroke: "rgb(220,226,224)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 71 L 94 80.5 L 93 80.5 L 93.5 71 Z "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,226,224)",
    stroke: "rgb(220,226,224)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 71 L 97 81.5 L 98 82.5 L 96 81.5 L 96.5 71 Z "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,226,224)",
    stroke: "rgb(220,226,224)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102.5 71 L 103 80.5 L 102 80.5 L 102.5 71 Z "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,226,224)",
    stroke: "rgb(220,226,224)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123.5 71 L 122.5 73 L 123.5 71 Z "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,226,224)",
    stroke: "rgb(220,226,224)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 71 L 135 84.5 L 134 84.5 L 134.5 71 Z "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,226,224)",
    stroke: "rgb(220,226,224)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 71 L 150 71.5 L 148 72.5 L 150 73 L 149.5 82 L 149 74.5 L 147 72.5 L 148.5 71 Z "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,226,224)",
    stroke: "rgb(220,226,224)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 72 L 155.5 74 L 153 74 L 153 82 L 155 82.5 L 153.5 83 L 152 81.5 L 152 73 L 156.5 72 Z "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,226,224)",
    stroke: "rgb(220,226,224)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 75.5 73 L 74.5 75 L 75.5 73 Z "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,226,224)",
    stroke: "rgb(220,226,224)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 73 L 110.5 75 L 111.5 73 Z "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,226,224)",
    stroke: "rgb(220,226,224)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 76 L 121 79.5 L 120 79.5 L 120.5 76 Z "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,226,224)",
    stroke: "rgb(220,226,224)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 77 L 80.5 79 L 79.5 77 Z "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,226,224)",
    stroke: "rgb(220,226,224)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 77 L 110 79.5 L 109 79.5 L 109.5 77 Z "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,226,224)",
    stroke: "rgb(220,226,224)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 50.5 79 L 51 80.5 L 49.5 83 L 49 81.5 L 50.5 79 Z "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,226,224)",
    stroke: "rgb(220,226,224)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 79 L 79 81.5 L 77 82.5 L 78 80.5 L 77.5 79 Z "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,226,224)",
    stroke: "rgb(220,226,224)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110.5 81 L 111.5 83 L 110.5 81 Z "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,226,224)",
    stroke: "rgb(220,226,224)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 81 L 114.5 83 L 115.5 81 Z "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,226,224)",
    stroke: "rgb(220,226,224)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 81 L 125.5 83 L 124.5 81 Z "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,226,224)",
    stroke: "rgb(220,226,224)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 81 L 132.5 83 L 131.5 81 Z "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,226,224)",
    stroke: "rgb(220,226,224)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 82 L 109.5 85 L 107.5 82 Z "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,226,224)",
    stroke: "rgb(220,226,224)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 83 L 86.5 85 L 85.5 83 Z "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,226,224)",
    stroke: "rgb(220,226,224)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 83 L 90.5 85 L 91.5 83 Z "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,226,224)",
    stroke: "rgb(220,226,224)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 83 L 155.5 85 L 156.5 83 Z "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,226,224)",
    stroke: "rgb(220,226,224)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 52.5 84 L 53 85.5 Q 52 88 47.5 87 L 47.5 86 Q 52.9 87.7 52.5 84 Z "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,226,224)",
    stroke: "rgb(220,226,224)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 85 L 70 86.5 L 65.5 87 L 64.5 85 Z "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 0 0 L 204 0 L 204 150 L 0 150 L 0 0 Z M 59 63 L 47 87 L 52 87 L 61 69 L 59 63 Z M 116 65 L 116 71 L 108 72 L 107 75 Q 105 83 110 85 Q 114 86 116 84 L 119 85 L 119 66 L 116 65 Z M 87 66 L 85 68 Q 86 72 83 71 Q 82 75 85 75 L 85 84 Q 86 86 91 85 Q 94 84 91 82 L 88 82 L 88 74 L 92 73 L 92 71 L 88 71 L 88 66 L 87 66 Z M 152 66 Q 149 67 150 71 L 147 73 L 149 75 L 150 84 Q 151 86 156 85 Q 159 84 156 82 L 153 82 L 153 74 L 157 73 L 153 71 Q 154 67 152 66 Z M 74 71 Q 71 73 72 78 L 78 81 L 77 83 L 75 82 Q 70 81 71 84 L 74 85 Q 79 86 81 84 L 82 81 L 81 79 L 75 76 L 77 73 L 79 74 Q 82 75 81 73 Q 79 69 74 71 Z M 93 71 Q 92 79 94 84 L 97 85 L 102 84 L 104 85 L 105 85 L 105 71 L 102 71 L 102 82 L 100 82 Q 98 84 97 82 L 97 71 L 93 71 Z M 124 71 L 120 77 L 121 82 Q 123 87 131 85 Q 135 83 132 81 L 128 83 L 124 81 L 125 78 L 133 78 L 132 72 Q 130 70 124 71 Z M 134 71 L 134 85 L 137 85 L 137 76 L 140 74 L 142 74 L 143 75 L 143 85 L 146 85 L 146 74 L 144 71 Q 139 70 138 72 L 134 71 Z M 60 74 L 66 87 L 70 87 L 65 76 Q 64 73 60 74 Z "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 73 L 116 74 Q 117.7 81.1 113.5 83 L 110 80.5 Q 108.8 74.3 112.5 73 Z "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 73 L 130 74.5 L 129.5 76 L 124 76 Q 122.9 73.3 125.5 74 L 126.5 73 Z "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(78,104,96)",
    stroke: "rgb(78,104,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 58.5 64 L 60 69.5 L 52 86 L 48 85.5 L 58.5 64 Z "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(78,104,96)",
    stroke: "rgb(78,104,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116 65 L 119 65.5 L 119 85 Q 116.3 86.1 117 83.5 L 115.5 84 L 110.5 85 Q 105.5 83.5 107 75.5 L 110.5 71 L 115.5 72 L 116 65 Z M 112 73 L 109 78 L 110 82 Q 111 84 115 83 Q 118 81 116 75 Q 115 72 112 73 Z "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(78,104,96)",
    stroke: "rgb(78,104,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 67 L 87 71 Q 92.2 69.3 91 73 L 87 74.5 Q 85.3 81.2 88.5 83 L 90.5 82 L 91 83.5 L 87.5 85 L 85 82.5 L 85 73 L 83 72.5 L 85 72 L 86.5 67 Z "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(78,104,96)",
    stroke: "rgb(78,104,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150 67 L 152 67 L 152 71 Q 157.2 69.3 156 73 L 152 73 L 152 81.5 L 154.5 83 L 156 82.5 L 154.5 85 Q 150.8 85.8 150 83.5 L 150 73.5 L 148.5 73 L 148.5 72 L 150 72 L 150 67 Z "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(78,104,96)",
    stroke: "rgb(78,104,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 74.5 71 Q 79.3 70.3 81 72.5 Q 79.8 75.3 78.5 73 Q 74.8 72.3 74 74.5 L 81 79.5 Q 81.8 83.3 79.5 84 L 74.5 85 L 72 84 Q 70.9 81.3 73.5 82 L 77.5 83 L 79 80.5 L 72 76.5 Q 71.3 71.8 74.5 71 Z "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(78,104,96)",
    stroke: "rgb(78,104,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94 71 L 96 71.5 L 96 81.5 Q 96.8 83.8 100.5 83 L 103 80.5 L 103 71 L 105 71.5 L 105 85 Q 102.3 86.1 103 83.5 L 101.5 84 L 96.5 85 L 94 82.5 L 94 71 Z "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(78,104,96)",
    stroke: "rgb(78,104,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 71 Q 130.3 70.2 132 73.5 L 133 78 L 123.5 78 L 123 79.5 L 125.5 83 L 132 82 Q 133.1 84.7 130.5 84 L 125.5 85 L 122 82.5 L 121 74.5 L 124.5 71 Z M 126 73 L 124 76 Q 131 77 130 75 Q 129 72 126 73 Z "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(78,104,96)",
    stroke: "rgb(78,104,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 71 L 138.5 72 L 143.5 71 L 146 74.5 L 146 85 L 143 83.5 L 143 74.5 L 141.5 73 L 137 74 L 137 84.5 L 135 85 L 135.5 71 Z "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(78,104,96)",
    stroke: "rgb(78,104,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 60 74 L 64 74 L 64 75.5 L 69 85.5 L 65.5 86 L 60 76.5 L 60 74 Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.20baf0465cdd193c7d44f26781602e06.svg";
export { ForwardRef as ReactComponent };